import React from 'react';
import PropTypes from 'prop-types';
import {Box, Button, Flex, Text} from 'rebass'
import {Backdrop, InlineBlock, Overlay} from "reakit";
import {DesktopBox, MobileBox} from "../Base";
import IosArrowForward from "react-ionicons/lib/IosArrowForward";
import styled from "styled-components";

const StyledOverlay = styled(Overlay)`
	min-width: 150px;
	min-height: 110px;

`

const StyledFlex = styled(Flex)`
	min-width: 150px;
	min-height: 110px;

`


const FixedControls = styled(Box)`
  position: relative;
  bottom: -54px;
  
  //z-index: 9990;
  width: 100%;

`;

const ConfirmRemove = props => {


	const { profile, noButton, handleConfirm} = props;

	return (
		<Overlay.Container>
			{overlay => (
				<InlineBlock>
					<MobileBox>
						<Flex flexDirection={'row'} mb={4} onClick={overlay.show}>
							<Text color={'meta'} mr={1} >Contact </Text>
							<IosArrowForward fontSize={'16px'} color={'#969a9b'}/>
						</Flex>
					</MobileBox>

					<DesktopBox>
						{noButton ?
							<Flex flexDirection={'row'} mb={4} onClick={overlay.show}>
								<Text color={'meta'} mr={1} >Contact </Text>
								<IosArrowForward fontSize={'16px'} color={'#969a9b'}/>
							</Flex> :<FixedControls pl={2}>
								<Button variant={'remove'} onClick={overlay.show}>Remove</Button>
							</FixedControls>
						}

					</DesktopBox>


					<Backdrop fade use={Overlay.Hide} {...overlay}/>
					<StyledOverlay fade slide {...overlay} >
						<Flex flexDirection={'column'} justifyContent={'space-between'}>
							<Box pb={3}>
								<Text textAlign={'center'}>Are you sure you'd like to remove {profile.first_name} {profile.last_name} ?</Text>
							</Box>
							<MobileBox>
								<StyledFlex justifyContent={'center'}>

									<Button variant={'approve'} p={1} m={1} bg={'green'} onClick={() => {
										handleConfirm()
										overlay.hide()
									}}>Yes</Button>
								</StyledFlex>
							</MobileBox>

							<DesktopBox>

								<Flex justifyContent={'center'} flexDirection={'column'}>


									<Flex justifyContent={'center'}>
										<Button variant={'approve'} p={1} m={1} bg={'green'} onClick={() => {
											handleConfirm()
											overlay.hide()
										}}>Yes</Button>
									</Flex>
								</Flex>
							</DesktopBox>

						</Flex>

					</StyledOverlay>
				</InlineBlock>
			)}
		</Overlay.Container>
	);
};

ConfirmRemove.propTypes = {
	handleConfirm: PropTypes.func,
	toggle: PropTypes.func,
	visible: PropTypes.bool,
	noButton: PropTypes.bool
};

ConfirmRemove.defaultProps = {
	handleConfirm: () => console.log('clicked confirm delete'),
	visible: false,
	noButton: false
};

export default ConfirmRemove;
